// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend_legend__2piD1","item":"Legend_item__2Dqo4","indicator":"Legend_indicator__GTNIX"};